package one.healthium.domain.common

import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.format
import kotlinx.datetime.format.char
import kotlinx.datetime.toLocalDateTime
import kotlin.time.Clock
import kotlin.time.Instant

internal object DateUtils {
    fun documentNameFormatted(date: Instant): String {
        return date.toLocalDateTime(TimeZone.currentSystemDefault()).format(
            LocalDateTime.Format {
                monthNumber()
                char('-')
                dayOfMonth()
                char('-')
                year()
            }
        )
    }

    fun todayDocumentNameFormatted(): String {
        val now = Clock.System.now()
        return documentNameFormatted(now)
    }
}

fun Instant.isToday(): Boolean {
    val today = Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault()).date
    val dateToCheck = this.toLocalDateTime(TimeZone.currentSystemDefault()).date
    return today == dateToCheck
}